export default __webpack_public_path__ + "static/media/Amtah.5c89b80e.jpg";